import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import PushNotificationPopup from '../PushNotification/PushNotificationPopup'
import { VdeBanner } from '../advertising/VdeBanner'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import ItineraryOptionsDialog from '../itineraryOptions/ItineraryOptionsDialog'
import ItineraryTimeOptionsDialog from '../itineraryOptions/ItineraryTimeOptionsDialog'
import Main from '../main/Main'
import Map from '../map/Map'
import VdeMarkers from '../map/markers/VdeMarkers'
import SearchDialog from '../search/SearchDialog'
import ItinerarySuggestContent from '../suggest/ItinerarySuggestContent'
import ItineraryHeaderForm from './ItineraryHeaderForm'
import ItineraryHomeMainContent from './ItineraryHomeMainContent'
import ItinerarySubHeader from './ItinerarySubHeader'
import ItineraryHPMetaManager from './seo/ItineraryHPMetaManager'
import StepsMarkers from './steps/StepsMarkers'

export const renderPage = () => {
  const { ItineraryHomePage, withSubHeader, withToaster } = PAGE_CLASSES

  return (
    <Page cssClasses={[ItineraryHomePage, withSubHeader, withToaster]} key="Page">
      <ItineraryHPMetaManager />
      <Map key="Map">
        <StepsMarkers />
        <VdeMarkers />
        <VdeBanner />
      </Map>
      <Header key="Header" subHeader={<ItinerarySubHeader key="ItinerarySubHeader" />}>
        <ItineraryHeaderForm key="ItineraryHeaderForm" />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<ItinerarySuggestContent />}>
        <AddressSearchDialogContent key="AddressSearchDialogContent" />
      </SearchDialog>
      <PushNotificationPopup />
      <Main key="Main">
        <ItineraryHomeMainContent id="ItineraryHomeMainContent" />
      </Main>
      <ItineraryOptionsDialog key="ItineraryOptionsDialog" />
      <ItineraryTimeOptionsDialog key="ItineraryTimeOptionsDialog" />
    </Page>
  )
}
